import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=13e5ca68&"
import script from "./Documents.jsx?vue&type=script&lang=js&"
export * from "./Documents.jsx?vue&type=script&lang=js&"
import style0 from "./Documents.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports